import { PdfFormField, PdfFormFieldType } from './common.constants';

export enum SubscriptionAgreementFieldName {
  Quantity = 'quantity',
  TotalCost = 'totalCost',
  Individual = 'individual',
  Joint = 'joint',
  Entity = 'entity',
  Retirement = 'retirement',
  PrimaryHolderName = 'primaryHolderName',
  PrimaryHolderSsid = 'primaryHolderSsid',
  PrimaryHolderAddress1 = 'primaryHolderAddress1',
  PrimaryHolderCity = 'primaryHolderCity',
  PrimaryHolderState = 'primaryHolderState',
  PrimaryHolderPostalCode = 'primaryHolderPostalCode',
  PrimaryHolderCountry = 'primaryHolderCountry',
  PrimaryHolderPhoneNumber = 'primaryHolderPhoneNumber',
  PrimaryHolderEmail = 'primaryHolderEmail',
  JointHolderName = 'jointHolderName',
  JointHolderSsid = 'jointHolderSsid',
  JointHolderAddress1 = 'jointHolderAddress1',
  JointHolderCity = 'jointHolderCity',
  JointHolderState = 'jointHolderState',
  JointHolderPostalCode = 'jointHolderPostalCode',
  JointHolderCountry = 'jointHolderCountry',
  JointHolderPhoneNumber = 'jointHolderPhoneNumber',
  JointHolderEmail = 'jointHolderEmail',
  NonAccredited = 'nonAccredited',
  Accredited = 'accredited',
  FinraMember = 'finraMember',
  NonFinraMember = 'nonFinraMember',
  PrimaryInvestorName = 'primaryInvestorName',
  PrimaryInvestorSignatureDate = 'primaryInvestorSignatureDate',
  PrimaryInvestorTitle = 'primaryInvestorTitle',
  PrimaryHolderSignature = 'primaryHolderSignature',
  JointInvestorName = 'jointInvestorName',
  JointInvestorSignatureDate = 'jointInvestorSignatureDate',
  JointInvestorTitle = 'jointInvestorTitle',
  JointHolderSignature = 'jointHolderSignature',
}

export const SubscriptionAgreementFieldList: PdfFormField[] = [
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.Quantity,
    description: 'Number of shares',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.TotalCost,
    description: 'Total investment amount',
  },
  {
    type: PdfFormFieldType.Checkbox,
    name: SubscriptionAgreementFieldName.Individual,
    description: 'Individual account type selection',
  },
  {
    type: PdfFormFieldType.Checkbox,
    name: SubscriptionAgreementFieldName.Joint,
    description: 'Joint account type selection',
  },
  {
    type: PdfFormFieldType.Checkbox,
    name: SubscriptionAgreementFieldName.Entity,
    description: 'Entity account type selection',
  },
  {
    type: PdfFormFieldType.Checkbox,
    name: SubscriptionAgreementFieldName.Retirement,
    description: 'Retirement account type selection',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.PrimaryHolderName,
    description: 'Full name of primary account holder',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.PrimaryHolderSsid,
    description: 'Social Security or Tax ID number of primary holder',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.PrimaryHolderAddress1,
    description: 'Primary account holder street address',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.PrimaryHolderCity,
    description: 'Primary account holder city',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.PrimaryHolderState,
    description: 'Primary account holder state or province',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.PrimaryHolderPostalCode,
    description: 'Primary account holder ZIP or postal code',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.PrimaryHolderCountry,
    description: 'Primary account holder country',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.PrimaryHolderPhoneNumber,
    description: 'Primary account holder contact phone number',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.PrimaryHolderEmail,
    description: 'Primary account holder email address',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.JointHolderName,
    description: 'Full name of joint account holder (if applicable)',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.JointHolderSsid,
    description: 'Social Security or Tax ID number of joint holder',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.JointHolderAddress1,
    description: 'Joint account holder street address',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.JointHolderCity,
    description: 'Joint account holder city',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.JointHolderState,
    description: 'Joint account holder state or province',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.JointHolderPostalCode,
    description: 'Joint account holder ZIP or postal code',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.JointHolderCountry,
    description: 'Joint account holder country',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.JointHolderPhoneNumber,
    description: 'Joint account holder contact phone number',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.JointHolderEmail,
    description: 'Joint account holder email address',
  },
  {
    type: PdfFormFieldType.Checkbox,
    name: SubscriptionAgreementFieldName.NonAccredited,
    description: 'Non-accredited investor account',
  },
  {
    type: PdfFormFieldType.Checkbox,
    name: SubscriptionAgreementFieldName.Accredited,
    description: 'Accredited investor account',
  },
  {
    type: PdfFormFieldType.Checkbox,
    name: SubscriptionAgreementFieldName.FinraMember,
    description: 'FINRA member affiliation',
  },
  {
    type: PdfFormFieldType.Checkbox,
    name: SubscriptionAgreementFieldName.NonFinraMember,
    description: 'No FINRA member affiliation',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.PrimaryInvestorName,
    description: 'Primary investor namefor signature',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.PrimaryInvestorSignatureDate,
    description: 'Date of primary investor signature',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.PrimaryInvestorTitle,
    description: 'Title or role of primary investor',
  },
  {
    type: PdfFormFieldType.Button,
    name: SubscriptionAgreementFieldName.PrimaryHolderSignature,
    description: 'Primary account holder signature field',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.JointInvestorName,
    description: 'Joint investor name for signature (if applicable)',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.JointInvestorSignatureDate,
    description: 'Date of joint investor signature',
  },
  {
    type: PdfFormFieldType.Text,
    name: SubscriptionAgreementFieldName.JointInvestorTitle,
    description: 'Title or role of joint investor',
  },
  {
    type: PdfFormFieldType.Button,
    name: SubscriptionAgreementFieldName.JointHolderSignature,
    description: 'Joint account holder signature field',
  },
];
